<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Book-Title--Front-Matter-">The Starfarers Series Books 1–2
    </p>
<p class="ORIM-Book-Subtitle--Front-Matter-">Starfarers * Transition
    </p>
<p class="ORIM-Author-Name--Front-Matter-">Vonda N. McIntyre</p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?8a998e8a